import React, { useState, useEffect, Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";


import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";
import {
	Button,
	Alert,
	Card,
	CardImg,
	CardBody,
	CardTitle,
	CardSubtitle,
	CardText,
} from "react-bootstrap";

import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { AppBar, Link, Toolbar, Typography } from "@mui/material";
import { ThemeProvider } from '@mui/material'

function StockSentiment() {

	// const [item1,setItems]=useState([]);
	// fetch("http://194.238.22.156:8080/get_stock_sentiment/")
	//         .then((response) => {
	// 			//console.log(response);
	// 			//setItems(response);

	// 			response.json();})
	//         .then((data) => {

	//             //setMessage("<Customer>" + qmessage + "[SEP]<BOT>" + data.response);
	// 			console.log("ok");
	// 			console.log(data);
	// 			setItems(data);
	//             //setItems(JSON.parse(data).response);
	//             //console.log(item1);
	//             //this.setState({ message: "" });
	//             //updateTextWithDelay();
	//             //aupdateTextWithDelay(data.response);
	//             //setQMessage('');
	//             //setMessage('');

	//         })
	//         .catch((error) => {
	//             console.error("Error fetching data:", error);
	//         });


	const [data, setData] = useState([]);
	const [status, setStatus] = useState();

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response1 = await fetch('http://157.173.222.203:8080/get_stock_sentiment_status/');
				const json1 = await response1.json();
				console.log(json1);


				setStatus(json1.response);
			} catch (error) {
				console.error('Error fetchingi status data:', error);
			}

		};

		fetchData();
	}, []);





	useEffect(() => {
		const fetchData = async () => {
			// try {
			// 	const response1 = await fetch('http://157.173.222.203:8080/get_stock_sentiment_status/');
			// 	const json1 = await response1.json();
			// 	console.log(json1);


			// 	setData(json1.response);
			//   } catch (error) {
			// 	console.error('Error fetchingi status data:', error);
			//   }
			try {
				const response = await fetch('http://157.173.222.203:8080/get_stock_sentiment/');
				const json = await response.json();

				// Assuming your JSON structure matches the fetched data
				const dataArray = Object.keys(json.response).map(category => ({
					category,
					positive: json.response[category].positive,
					negative: json.response[category].negative,
					notSure: json.response[category]['not sure']
				}));

				setData(dataArray);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchData();
	}, []);
	return (
		<ThemeProvider theme={theme}>
			<GlobalStyles />
			<div className='fillOutPage property'>
				<Header />

				<main className="my-5 py-5">
					<Container className="px-0">

						<Row
							noGutters
							className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
						>


							<Col
								xs={{ order: 1 }}
								md={{ size: 7, offset: 1 }}
								tag="section"
								className="py-5 mb-5 py-md-0 mb-md-0"
							>
								<Fragment>
									<div className="position-relative">
										<Card>
											<Typography variant="h5" style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
												Industry Sentiment as on {status}

											</Typography></Card>
										<table style={{ width: '100%', borderCollapse: 'collapse', borderSpacing: '0' }}>
											<thead>
												<tr style={{ border: '5px solid #dddddd' }} >
													<th style={{ border: '5px solid #dddddd' }}>Category</th>
													<th style={{ border: '5px solid #dddddd' }}>Positive</th>
													<th style={{ border: '5px solid #dddddd' }}>Negative</th>
													<th style={{ border: '5px solid #dddddd' }}>Not Sure</th>
												</tr>
											</thead>
											<tbody>
												{data.map((item, index) => (
													<tr style={{ border: '5px solid #dddddd' }} key={index}>
														<td style={{ border: '5px solid #dddddd' }}>{item.category}</td>
														<td style={{ border: '5px solid #dddddd' }}>{item.positive}</td>
														<td style={{ border: '5px solid #dddddd' }}>{item.negative}</td>
														<td style={{ border: '5px solid #dddddd' }}>{item.notSure}</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>


								</Fragment>
							</Col>
						</Row>







					</Container>
				</main><Footer />
			</div>
		</ThemeProvider>);
}

export default StockSentiment;
